import { FC, PropsWithChildren } from 'react'
import { useSongRemixTable } from '../hooks'
import { ArpTableContext } from './ArpTableContext'

interface SongRemixRootProps extends PropsWithChildren {
  id: number
}
export const SongRemixRoot: FC<SongRemixRootProps> = ({ id, children }) => {
  const contextData = useSongRemixTable(id)
  return <ArpTableContext.Provider value={contextData}>{children}</ArpTableContext.Provider>
}
